module.exports = __webpack_public_path__ + "img/donante-ssp-baja-california.a196dbfb.png";